import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl-next';
import Button from '@atlaskit/button';
import { Popup } from '@atlaskit/popup';
import { Bleed } from '@atlaskit/primitives';
import { groupRequestTypes } from '../../../../../common/utils/ticket-types';
import { messages } from './messages';
import { RequestTypeLink } from './request-type-link';
import { PopupItem } from './styled';
export const RequestTypes = ({
  isServiceProject,
  projectKey,
  requestTypes,
  requestTypeCategories,
  simplifiedProject
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const groupedRequestTypes = groupRequestTypes(requestTypes);
  const ids = Object.keys(groupedRequestTypes);
  if (ids.length === 0) return null;
  if (ids.length === 1) {
    const rt = groupedRequestTypes[ids[0]][0];
    return /*#__PURE__*/React.createElement(RequestTypeLink, {
      requestType: rt,
      isServiceProject: isServiceProject,
      projectKey: projectKey,
      requestTypeCategories: requestTypeCategories,
      simplifiedProject: simplifiedProject
    });
  }
  const uniqueRequestTypes = Object.values(groupedRequestTypes).map(rts => rts[0]);
  const buttonLabel = isServiceProject ? messages.multipleRequestTypesLabel : messages.multipleIssueTypesLabel;
  return /*#__PURE__*/React.createElement(Popup, {
    isOpen: isPopupOpen,
    onClose: () => setIsPopupOpen(false),
    placement: "bottom-start",
    shouldRenderToParent: true,
    content: () => uniqueRequestTypes.map(rt => /*#__PURE__*/React.createElement(PopupItem, {
      key: rt.id
    }, /*#__PURE__*/React.createElement(RequestTypeLink, {
      requestType: rt,
      isServiceProject: isServiceProject,
      projectKey: projectKey,
      requestTypeCategories: requestTypeCategories,
      simplifiedProject: simplifiedProject
    }))),
    trigger: triggerProps => /*#__PURE__*/React.createElement(Bleed, {
      inline: "space.150"
    }, /*#__PURE__*/React.createElement(Button, _extends({}, triggerProps, {
      appearance: "link",
      spacing: "compact"
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
      ,
      style: {
        borderRadius: '12px'
      },
      isSelected: isPopupOpen,
      onClick: () => setIsPopupOpen(!isPopupOpen)
    }), /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, buttonLabel, {
      values: {
        count: uniqueRequestTypes.length
      }
    }))))
  });
};